import { get } from 'lodash-es';
import { emptyArray } from 'ui-components/default-props/empty';
import type { CarrierSharingState, ServiceGroup } from './carrier-sharing.types';
import type { RootState } from 'store/root-state';

export const serviceGroups = (state: CarrierSharingState): ServiceGroup[] => get(state, 'serviceGroups', emptyArray as ServiceGroup[]);
export const fulfillmentPlanId = (state: CarrierSharingState): number => get(state, 'fulfillmentPlanId', 0);
export const isRequired = (state: CarrierSharingState): boolean => get(state, 'isRequired', false);
export const isLoading = (state: CarrierSharingState): boolean | undefined => get(state, 'isLoading');

export const selectCarrierSharingfulfillmentPlanId = (state: RootState): number => fulfillmentPlanId(get(state, 'carrierSharing'));
export const selectCarrierSharingisLoading = (state: RootState): boolean | undefined => isLoading(get(state, 'carrierSharing'));
export const selectCarrierSharingisRequired = (state: RootState): boolean => isRequired(get(state, 'carrierSharing'));
export const selectCarrierSharingserviceGroups = (state: RootState): ServiceGroup[] => serviceGroups(get(state, 'carrierSharing'));
